import api from './api'

const BASE_URL = 'https://wi4l39akng.execute-api.ap-southeast-1.amazonaws.com/dev'

// 项目阶段项接口
export interface ProjectPhaseItem {
  phaseId: string
  phaseName: string
  remark?: string // 实际返回的是remark而不是description
  createTime?: string
  updateTime?: string
  createBy?: string
  updateBy?: string
  version?: number
  // 保留原有字段以兼容其他可能的使用场景
  phaseCode?: string
  description?: string
}

// 项目阶段列表响应接口
export interface ProjectPhaseListResponse {
  code: string
  info: string
  data: {
    total: number
    pageNum: number
    pageSize: number
    totalPage: number
    list: ProjectPhaseItem[]
  }
}

// 项目阶段详情响应接口
export interface ProjectPhaseDetailResponse {
  code: string
  info: string
  data: ProjectPhaseItem
}

// 保存项目阶段请求接口
export interface SaveProjectPhaseRequest {
  phaseName: string
  remark?: string
}

// 保存项目阶段响应接口
export interface SaveProjectPhaseResponse {
  code: string
  info: string
  data: any
}

// 编辑项目阶段请求接口
export interface EditProjectPhaseRequest {
  phaseId: string
  phaseName: string
  remark?: string
}

// 编辑项目阶段响应接口
export interface EditProjectPhaseResponse {
  code: string
  info: string
  data: any
}

// 删除项目阶段请求接口
export interface DeleteProjectPhaseRequest {
  phaseId: string
}

// 删除项目阶段响应接口
export interface DeleteProjectPhaseResponse {
  code: string
  info: string
  data: any
}

// 获取项目阶段列表
export const getProjectPhaseList = async (
  pageNum: number = 1,
  pageSize: number = 20
): Promise<ProjectPhaseListResponse> => {
  try {
    const response = await api.get(`${BASE_URL}/OTA-ProjectPhaseHandler/list`, {
      params: {
        pageNum,
        pageSize,
      },
    })
    return response as unknown as ProjectPhaseListResponse
  } catch (error) {
    console.error('获取项目阶段列表失败:', error)
    throw error
  }
}

// 获取项目阶段详情
export const getProjectPhaseDetail = async (phaseId: string): Promise<ProjectPhaseDetailResponse> => {
  try {
    const response = await api.get(`${BASE_URL}/OTA-ProjectPhaseHandler/detail`, {
      params: { phaseId },
    })
    return response as unknown as ProjectPhaseDetailResponse
  } catch (error: any) {
    // 处理404错误
    if (error.response?.status === 404) {
      throw new Error('项目阶段不存在')
    }
    console.error('获取项目阶段详情失败:', error)
    throw error
  }
}

// 保存项目阶段
export const saveProjectPhase = async (data: SaveProjectPhaseRequest): Promise<SaveProjectPhaseResponse> => {
  try {
    const response = await api.post(`${BASE_URL}/OTA-ProjectPhaseHandler/save`, JSON.stringify(data), {
      headers: { 'Content-Type': 'text/plain' },
    })
    return response as unknown as SaveProjectPhaseResponse
  } catch (error) {
    console.error('保存项目阶段失败:', error)
    throw error
  }
}

// 编辑项目阶段
export const editProjectPhase = async (data: EditProjectPhaseRequest): Promise<EditProjectPhaseResponse> => {
  try {
    const response = await api.post(`${BASE_URL}/OTA-ProjectPhaseHandler/edit`, JSON.stringify(data), {
      headers: { 'Content-Type': 'text/plain' },
    })
    return response as unknown as EditProjectPhaseResponse
  } catch (error) {
    console.error('编辑项目阶段失败:', error)
    throw error
  }
}

// 删除项目阶段
export const deleteProjectPhase = async (data: DeleteProjectPhaseRequest): Promise<DeleteProjectPhaseResponse> => {
  try {
    const response = await api.post(`${BASE_URL}/OTA-ProjectPhaseHandler/delete`, JSON.stringify(data), {
      headers: { 'Content-Type': 'text/plain' },
    })
    return response as unknown as DeleteProjectPhaseResponse
  } catch (error) {
    console.error('删除项目阶段失败:', error)
    throw error
  }
}

// 获取项目阶段名称列表（用于下拉选择）
export const getProjectPhaseNameList = async (): Promise<ProjectPhaseItem[]> => {
  try {
    const response = await api.get(`${BASE_URL}/OTA-ProjectPhaseHandler/listProjectPhaseNames`)
    if (response.code === '200') {
      return response.data as unknown as ProjectPhaseItem[]
    }
    return []
  } catch (error) {
    console.error('获取项目阶段名称列表失败:', error)
    return []
  }
}
